import Vue from 'vue';
import Vuex from 'vuex';
import sharedMutations from 'vuex-shared-mutations';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    fullName: null,
    avatar: null,
    roles: null,
    timezone: null,
    dateFormat: null,
    ragAnalyzerEnabled: false,
  },
  mutations: {
    initialiseStore(state) {
      if (localStorage.avatar) {
        state.avatar = localStorage.avatar;
      }
      if (localStorage.roles) {
        // Parse roles from localStorage as they might be stored as JSON string
        try {
          state.roles = JSON.parse(localStorage.roles);
        } catch (e) {
          // If not JSON, use as is
          state.roles = localStorage.roles;
        }
      }
      if (localStorage.timezone) {
        state.timezone = localStorage.timezone;
      }
      if (localStorage.dateFormat) {
        state.dateFormat = localStorage.dateFormat;
      }
      if (localStorage.userfullname) {
        state.fullName = localStorage.userfullname;
      }
      // ragAnalyzerEnabled is fetched from the backend server, not localStorage
    },
    setAvatar(state, avatar) {
      if (avatar) {
        localStorage.avatar = avatar;
        state.avatar = avatar;
      } else {
        localStorage.removeItem('avatar');
        state.avatar = null;
      }
    },
    setRoles(state, roles) {
      if (roles) {
        // Store roles as JSON if it's an array or object
        if (typeof roles === 'object') {
          localStorage.roles = JSON.stringify(roles);
        } else {
          localStorage.roles = roles;
        }
        state.roles = roles;
      } else {
        localStorage.removeItem('roles');
        state.roles = null;
      }
    },
    setTimezone(state, timezone) {
      if (timezone) {
        localStorage.timezone = timezone;
        state.timezone = timezone;
      } else {
        localStorage.removeItem('timezone');
        state.timezone = null;
      }
    },
    setDateFormat(state, dateFormat) {
      if (dateFormat) {
        localStorage.dateformat = dateFormat;
        state.dateFormat = dateFormat;
      } else {
        localStorage.removeItem('dateformat');
        state.dateFormat = null;
      }
    },
    setFullName(state, fullName) {
      if (fullName) {
        localStorage.userfullname = fullName;
        state.fullName = fullName;
      } else {
        localStorage.removeItem('userfullname');
        state.fullName = null;
      }
    },
    setRagAnalyzerEnabled(state, enabled) {
      state.ragAnalyzerEnabled = !!enabled;
    },
  },
  getters: {
    avatar: state => {
      return state.avatar ? state.avatar : '0';
    },
    roles: state => {
      // Convert string roles to array if needed
      if (state.roles) {
        if (typeof state.roles === 'string') {
          return state.roles.split(',').map(role => role.trim());
        }
        return state.roles;
      }
      return [];
    },
    timezone: state => {
      return state.timezone ? state.timezone : 'Etc/UCT';
    },
    dateFormat: state => {
      return state.dateFormat ? state.dateFormat : 'YYYY-MM-DD';
    },
    fullName: state => {
      return state.fullName ? state.fullName : 'Undefined';
    },
    ragAnalyzerEnabled: state => state.ragAnalyzerEnabled,
  },
  plugins: [
    sharedMutations({
      predicate: ['setAvatar', 'setRoles', 'setTimezone', 'setDateFormat', 'setFullName'],
    }),
  ],
});
